/* @flow */
import MessageSystemItem from './MessageSystemItem.jsx';
import * as React from 'react';
import { ChatSystemMessage } from 'entities/ChatMessage';

import './styles/MessageListSystemItem.scss';

type Props = {
  messages: ChatSystemMessage[],
};

class MessageListSystemItem extends React.PureComponent<Props> {
  render() {
    const { messages } = this.props;

    return (
      <li className="MessageListSystemItem">
        {messages.map(m => (
          <MessageSystemItem key={m.id} message={m} />
        ))}
      </li>
    );
  }
}

export default MessageListSystemItem;
